"use strict";
exports.tradeIn = validate10;
const schema11 = { "$id": "tradeIn", "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "body": { "type": "string" }, "condition": { "enum": ["high", "target", "low"] }, "doors": { "type": "integer" }, "drivetrain": { "type": "string" }, "engine": { "type": "string" }, "fuelType": { "type": "string" }, "id": { "type": "string" }, "make": { "type": "string" }, "miles": { "type": "integer" }, "model": { "type": "string" }, "trim": { "type": "string" }, "year": { "type": "integer" } } };
function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="tradeIn" */ ; let vErrors = null; let errors = 0; if (errors === 0) {
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.body !== undefined) {
            const _errs1 = errors;
            if (typeof data.body !== "string") {
                validate10.errors = [{ instancePath: instancePath + "/body", schemaPath: "#/properties/body/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                return false;
            }
            var valid0 = _errs1 === errors;
        }
        else {
            var valid0 = true;
        }
        if (valid0) {
            if (data.condition !== undefined) {
                let data1 = data.condition;
                const _errs3 = errors;
                if (!(((data1 === "high") || (data1 === "target")) || (data1 === "low"))) {
                    validate10.errors = [{ instancePath: instancePath + "/condition", schemaPath: "#/properties/condition/enum", keyword: "enum", params: { allowedValues: schema11.properties.condition.enum }, message: "must be equal to one of the allowed values" }];
                    return false;
                }
                var valid0 = _errs3 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.doors !== undefined) {
                    let data2 = data.doors;
                    const _errs4 = errors;
                    if (!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))) {
                        validate10.errors = [{ instancePath: instancePath + "/doors", schemaPath: "#/properties/doors/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                        return false;
                    }
                    var valid0 = _errs4 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.drivetrain !== undefined) {
                        const _errs6 = errors;
                        if (typeof data.drivetrain !== "string") {
                            validate10.errors = [{ instancePath: instancePath + "/drivetrain", schemaPath: "#/properties/drivetrain/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                            return false;
                        }
                        var valid0 = _errs6 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.engine !== undefined) {
                            const _errs8 = errors;
                            if (typeof data.engine !== "string") {
                                validate10.errors = [{ instancePath: instancePath + "/engine", schemaPath: "#/properties/engine/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                return false;
                            }
                            var valid0 = _errs8 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.fuelType !== undefined) {
                                const _errs10 = errors;
                                if (typeof data.fuelType !== "string") {
                                    validate10.errors = [{ instancePath: instancePath + "/fuelType", schemaPath: "#/properties/fuelType/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                    return false;
                                }
                                var valid0 = _errs10 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.id !== undefined) {
                                    const _errs12 = errors;
                                    if (typeof data.id !== "string") {
                                        validate10.errors = [{ instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                        return false;
                                    }
                                    var valid0 = _errs12 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.make !== undefined) {
                                        const _errs14 = errors;
                                        if (typeof data.make !== "string") {
                                            validate10.errors = [{ instancePath: instancePath + "/make", schemaPath: "#/properties/make/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                            return false;
                                        }
                                        var valid0 = _errs14 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.miles !== undefined) {
                                            let data8 = data.miles;
                                            const _errs16 = errors;
                                            if (!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))) {
                                                validate10.errors = [{ instancePath: instancePath + "/miles", schemaPath: "#/properties/miles/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                                return false;
                                            }
                                            var valid0 = _errs16 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.model !== undefined) {
                                                const _errs18 = errors;
                                                if (typeof data.model !== "string") {
                                                    validate10.errors = [{ instancePath: instancePath + "/model", schemaPath: "#/properties/model/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                    return false;
                                                }
                                                var valid0 = _errs18 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.trim !== undefined) {
                                                    const _errs20 = errors;
                                                    if (typeof data.trim !== "string") {
                                                        validate10.errors = [{ instancePath: instancePath + "/trim", schemaPath: "#/properties/trim/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
                                                        return false;
                                                    }
                                                    var valid0 = _errs20 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.year !== undefined) {
                                                        let data11 = data.year;
                                                        const _errs22 = errors;
                                                        if (!(((typeof data11 == "number") && (!(data11 % 1) && !isNaN(data11))) && (isFinite(data11)))) {
                                                            validate10.errors = [{ instancePath: instancePath + "/year", schemaPath: "#/properties/year/type", keyword: "type", params: { type: "integer" }, message: "must be integer" }];
                                                            return false;
                                                        }
                                                        var valid0 = _errs22 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    else {
        validate10.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" }];
        return false;
    }
} validate10.errors = vErrors; return errors === 0; }
exports.consumerId = validate11;
const schema12 = { "$id": "consumerId", "$schema": "http://json-schema.org/draft-07/schema#", "type": "string", "format": "uuid" };
const formats0 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="consumerId" */ ; let vErrors = null; let errors = 0; if (errors === 0) {
    if (errors === 0) {
        if (typeof data === "string") {
            if (!(formats0.test(data))) {
                validate11.errors = [{ instancePath, schemaPath: "#/format", keyword: "format", params: { format: "uuid" }, message: "must match format \"" + "uuid" + "\"" }];
                return false;
            }
        }
        else {
            validate11.errors = [{ instancePath, schemaPath: "#/type", keyword: "type", params: { type: "string" }, message: "must be string" }];
            return false;
        }
    }
} validate11.errors = vErrors; return errors === 0; }
